module.exports = __webpack_public_path__ + "media/images/menu/ananke-427c0493c4fad6f3ef6c79c9e6536e6d.jpg";